module.exports = __webpack_public_path__ + "static/media/spenmo-logo-orange-compact.35e895b9.svg";